var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconObservacao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75496 14.3242L2.7818 12.4204C2.78914 11.8998 2.99921 11.4025 3.36738 11.0343L11.3539 3.04788C12.3732 2.02851 14.0259 2.02851 15.0453 3.04788C16.0647 4.06724 16.0647 5.71996 15.0453 6.73933L7.05884 14.7258C6.69067 15.094 6.19343 15.3041 5.67282 15.3114L3.76896 15.3382C3.20569 15.3462 2.74702 14.8875 2.75496 14.3242Z",
    fill: "#FAE6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7528 2.44677C12.1041 1.09546 14.295 1.09546 15.6464 2.44677C16.9977 3.79808 16.9977 5.98899 15.6464 7.3403L7.65988 15.3268C7.13524 15.8514 6.42668 16.1508 5.6848 16.1612L3.78094 16.1881C2.73889 16.2028 1.89036 15.3542 1.90504 14.3122L1.93188 12.4083C1.94234 11.6664 2.2417 10.9579 2.76634 10.4332L10.7528 2.44677ZM14.4443 3.64885C13.7569 2.96143 12.6423 2.96143 11.9549 3.64885L3.96842 11.6353C3.75673 11.847 3.63593 12.1329 3.63171 12.4323L2.7818 12.4203L3.63171 12.4323L3.60488 14.3361C3.60368 14.4206 3.67248 14.4894 3.75697 14.4882L5.66083 14.4614C5.96019 14.4572 6.2461 14.3364 6.4578 14.1247L14.4443 6.13822C15.1317 5.4508 15.1317 4.33627 14.4443 3.64885Z",
    fill: "#A51713"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1995 7.97142L10.124 4.8945L11.3258 3.69214L14.4013 6.76906L13.1995 7.97142Z",
    fill: "#A51713"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1986 16.0172C10.1986 15.5478 10.5792 15.1672 11.0486 15.1672H18.0474C18.5169 15.1672 18.8974 15.5478 18.8974 16.0172C18.8974 16.4867 18.5169 16.8672 18.0474 16.8672H11.0486C10.5792 16.8672 10.1986 16.4867 10.1986 16.0172Z",
    fill: "#A51713"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconObservacao);
export default __webpack_public_path__ + "static/media/icon_observacao.e8341a407eca3d49afa6b75198667df8.svg";
export { ForwardRef as ReactComponent };